import script from "./TagForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TagForm.vue?vue&type=script&setup=true&lang=js"

import "./TagForm.vue?vue&type=style&index=0&id=838ad200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-838ad200"]])

export default __exports__